﻿import { IComponent, Component, Inject, Input, Output } from "@fiqas/angular-utils";
import { FIQAssist } from "../../app";
import { Application } from "../application"
import { IDisposable } from "../../interfaces/general";
import { ServiceCaseService } from "../../services/fiqassistApi/serviceCaseService"
import { CaseFileData } from "../../models/file"
import { RequestData, Request } from "../../models/serviceCase"
import { RequestBase } from "./requestBase"
import { IsProcessingService } from "../../services/isProcessingService";
import { DialogService } from "../../services/dialogService";
import { LogService } from "../../services/logService";
import { ServiceUtils } from "../../services/serviceBase";
import { AuthorizationService } from "../../services/authorizationService";
import { TranslationService } from "../../services/TranslationService";
import { Utils } from "@fiqas/utils";
import { SaveDialog } from "../general/savedialog";
import { AuthenticationService } from "../../services/authenticationService";

@Component({
    module: FIQAssist,
    selector: "requestEntry",
    templateUrl: "views/request.entry.html",
    require: {
        application: "^application",
        base: "^requestBase"
    }
})
class RequestEntry implements IComponent {
    private application: Application;
    private base: RequestBase
    @Input() private $router: ng.Router;
    public files: CaseFileData[] = [];
    private titleiserror: boolean;
    private descriptioniserror: boolean;
    private customeriserror: boolean;
    public get readOnly() {
        return this.authorizationService.currentRoleIn(["FQS"]);
    }

    constructor(
        @Inject() private authorizationService: AuthorizationService,
        @Inject() private serviceCaseService: ServiceCaseService,
        @Inject() private isProcessingService: IsProcessingService,
        @Inject('$window') private $window: ng.IWindowService,
        @Inject('$q') private $q: ng.IQService,
        @Inject('$element') private $element: ng.IRootElementService,
        @Inject('$timeout') private $timeout: ng.ITimeoutService,
        @Inject() private dialogService: DialogService,
        @Inject() private logService: LogService,
        @Inject() private TranslationService: TranslationService,
        @Inject('$uibModal') private $modal: angular.ui.bootstrap.IModalService,
        @Inject() private saveDialog: SaveDialog,
    ) {
    }

    /**
    * called by the Router at the end of a successful navigation. Only one of $routerOnActivate and $routerOnReuse will be called depending upon the result of a call to $routerCanReuse.
    */
    public async $routerOnActivate(next?: angular.ComponentInstruction, prev?: angular.ComponentInstruction) {
         await this.authorizationService.roleLoaded;
        if (next['routeName'] == "New" && this.authorizationService.currentRoleIn(["FQS"])) {
            this.$timeout(() => this.back());
            return false;
        }
    }

    public async $routerOnReuse(next?: angular.ComponentInstruction, prev?: angular.ComponentInstruction) {
         await this.authorizationService.roleLoaded;
    }

    async $onInit() {
        this.base.isNew = true;
        var custs = await this.application.customers;
        this.requestData = {
            start: undefined, // ISODateString
            title: "", // string,
            description: "", //string
            customer: undefined, // WebLink,
            contactPerson: undefined, // WebLink,
            fiqasOwnership: undefined, // WebLink,
            status: "open", // Status,
            priority: "medium", // Priority,
            internalTaskLink: undefined, //string
            caseNumber: undefined, //string
            parentCaseNumber: undefined, //string
            increasedPriority: false, // boolean
            requestedDeadline: undefined, // ISODateString
            customerReference: undefined, //string
            actionRequired: false,
            createdOn: undefined,
            createdBy: undefined,
            caseCause: undefined,
            caseOwnership: undefined,
            responsibleSDEmployee: undefined,
            budgetIndication: undefined,
            approvedHoursMin: undefined,
            approvedHoursMax: undefined,
            actualHoursSpent: undefined,
            approvedHoursCommentBySD: undefined,
            spTsTask: undefined,
            rememberMeDate: undefined,
            rememberMeReason: undefined,
            ignoreChatMemoSequence: undefined,
        }
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        this.minDeadline = today;
        this.base.Title = "I_HAVE_A_REQUEST";
        this.base.activeMenuItem = 'request';
        this.base.isDirty = false;
        var cust = custs.length == 1 ? custs[0] : custs.filter(c => c.checked).length == 1 ? custs.filter(c => c.checked).shift() : null;
        if (cust) {
            var customers = await this.application.userService.Customers;
            var cid = customers.items.filter(y => y.id.ref == cust.key).shift().id;
            this.requestData.customer = cid;
        }
    }

    public $routerCanDeactivate(next?: angular.ComponentInstruction, prev?: angular.ComponentInstruction) {
        if (this.authorizationService.dirty) {
            return this.saveDialog.Save().then(result => {
                let res = result === SaveDialog.Discard;
                return new Promise(resolve => {
                    this.$timeout(25).finally(() => resolve(res));
                });
            }).catch(() => { return false });
        }
        return true;
    }

    $onDestroy() {
        this.base.activeMenuItem = '';
    }

    public onNewAttachment(file: CaseFileData) {
        this.onfileadded(file);
    }

    private onfileadded(file: CaseFileData) {
        this.files.push(file);
        this.base.isDirty = true;
    }

    private onfileremoved(file: CaseFileData) {
        this.files = this.files.filter(f => f != file);
    }

    public oneditorvaluechanged(value: string) {
        if (this.requestData.description != value) {
            this.requestData.description = value;
            this.base.isDirty = true;
            this.descriptioniserror = false;
        }
    }
    public descriptionchanged(value: string) {
        if (this.requestData.title != value) {
            this.requestData.title = value;
            this.base.isDirty = true;
            this.titleiserror = false;
        }
    }
    public custrefchanged(value: string) {
        if (this.requestData.customerReference != value) {
            this.requestData.customerReference = value;
            this.base.isDirty = true;
        }
    }

    public prioritychanged(priority: any) {
        if (this.requestData.priority != priority) {
            this.requestData.priority = priority;
            this.base.isDirty = true;
        }
    }

    public deadlineDT: Date;
    public async OnDateChanged(date: Date) {
        if (date === undefined)
            return;
        if (await this.checkDeadlineChange(date)) {
            var oldDate = this.deadlineDT;
            this.deadlineDT = date;
            this.base.isDirty = (oldDate ? oldDate.getTime() : 0) !== (this.deadlineDT ? this.deadlineDT.getTime() : 0);
        } else {
            this.deadlineDT = this.deadlineDT ? this.deadlineDT.clone() : null;
        }
    }
    private deadlineThresholdModal = null;
    public async checkDeadlineChange(value: Date) {
        if (
            (!!value === false && !!this.deadlineDT == false)
            || Date.dateEquals(this.deadlineDT, value)
            || this.deadlineThresholdModal !== null
            || !!value && value < this._minDeadline
        ) {
            return false; // No change
        } else if (
            (value == null && !!this.deadlineDT)
            || value >= this._deadlineThreshold
        ) {
            return true; // Change, plus new value null or over threshold.
        } else {
            // Change, but date falls in threshold time
            let options: ng.ui.bootstrap.IModalSettings = {
                animation: false,
                templateUrl: 'handle_thresholddeadline.html',
                controller: ConfirmDeadlineComponent,
                controllerAs: '$modal',
                resolve: {
                    page: () => this
                }
            };
            this.deadlineThresholdModal = this.$modal.open(options);
            try {
                let result = await this.deadlineThresholdModal.result;
                if (result == "yes" && this.deadlineRemark && this.deadlineRemark.length > 1) {
                    return true;
                } else {
                    this.deadlineRemark = null;
                }
            } catch (_) {
            } finally {
                this.deadlineThresholdModal.close();
                this.deadlineThresholdModal = null;
            }
            return false;
        }
    }
    private _minDeadline: Date;
    private _deadlineThreshold: Date;
    public get minDeadline(): Date {
        return (this.deadlineToolboxIsOpen) ? this._deadlineThreshold : this._minDeadline;
    }
    public set minDeadline(value: Date) {
        this._minDeadline = value;
        this._deadlineThreshold = value.addDays(7);
    }
    public get deadlineThreshold(): Date { return this._deadlineThreshold; };
    public deadlineRemark: string = "";
    public deadlineBoxOpen() {
        this.deadlineToolboxIsOpen = true;
        this.deadlineTooltipText = this.deadlineToolboxIsOpen ? '' : `${this.TranslationService.Translate('DEADLINE_TOOLTIP')}${(this.deadlineDT) ? `: ${this.deadlineDT.toLocaleDateString('nl-NL')}` : ''}`;
    }
    public deadlineBoxClose() {
        this.deadlineToolboxIsOpen = false;
        this.deadlineTooltipText = this.deadlineToolboxIsOpen ? '' : `${this.TranslationService.Translate('DEADLINE_TOOLTIP')}${(this.deadlineDT) ? `: ${this.deadlineDT.toLocaleDateString('nl-NL')}` : ''}`;
    }
    public deadlineToolboxIsOpen: boolean =  false;
    public deadlineTooltipText: string = this.deadlineToolboxIsOpen ? '' : `${this.TranslationService.Translate('DEADLINE_TOOLTIP')}${(this.deadlineDT) ? `: ${this.deadlineDT.toLocaleDateString('nl-NL')}` : ''}`;


    public async customerchanged(customerKeys: any[]) {
        this.customeriserror = false;
        var sel = (customerKeys && customerKeys.length > 0) ? customerKeys[0] : undefined;
        if (sel) {
            var customers = await this.application.userService.Customers;
            var cid = customers.items.filter(y => y.id.ref == sel).shift().id;
            this.requestData.customer = cid;
            if ((await this.application.customers).length > 1)
                this.base.isDirty = true;
        } else {
            this.requestData.customer = undefined;
        }
    }

    private get requestData(): RequestData { return this.base ? this.base.Data : undefined; }
    private set requestData(value: RequestData) {
        this.base.Data = value as Request;
    }

    public async save() {
        this.requestData.requestedDeadline = this.deadlineDT && (this.deadlineRemark || this.deadlineDT >= this._deadlineThreshold) ? this.deadlineDT.toISODateString() : undefined;
        if (this.validate()) {
            this.requestData.start = new Date().toISODateTimeString();
            if (this.requestData.customerReference == undefined)
                this.requestData.customerReference = '';

            try {
                this.isProcessingService.StartProcessing();
                var req = await this.serviceCaseService.NewRequest(this.requestData);
                var request = <Request>(await req.value);
                request = await this.serviceCaseService.fillImageSources(request);
                this.base.Data = request;
                if (request.requestedDeadline && this.deadlineRemark) {
                    await this.serviceCaseService.AddCorrespondence(request.correspondence, {
                        content: this.deadlineRemark,
                        createdOn: new Date().toISOString(),
                        createdBy: '',
                        bySupportEmployee: this.authorizationService.currentRoleIn(["SD"]),
                        byInternalCustomer: this.authorizationService.lowRole === "CUST" && this.authorizationService.highRole === "FQS",
                        byCustomer: this.authorizationService.lowRole === "CUST" && this.authorizationService.highRole === "CUST",
                        correspondenceType: undefined
                    });
                }
                var myfilePromises = this.files.map(x => this.serviceCaseService.AddFile(this.base.Data.files, x));
                await Promise.all(myfilePromises)
                this.$router.navigate(['Edit', { number: request.caseNumber }]);
                this.base.isDirty = false;
            } catch (error) {
                if (ServiceUtils.IsUnauthorizedResponse(error)) {
                    this.base.isDirty = false;
                    return;
                }
                this.application.setSeqUrl(error);
                this.logService.error('RequestEntry', 'Error saving request', error);
                this.dialogService.showErrorDialog('error', 'ERROR', 'REQUEST_CREATE_ERROR', { errorResult: error, translate: true });
            } finally {
                this.isProcessingService.StopProcessing();
            }
        }
    }

    private validate(): boolean {
        var result: boolean = true;
        if (this.requestData.title && this.requestData.title.length > 0)
            this.base.clearErrorClass(this.$element, 'edittitle');
        else {
            this.base.setErrorClass(this.$element, 'edittitle');
            this.titleiserror = true;
            result = false;
        }
        if (this.requestData.description && this.requestData.description.length > 0)
            this.base.clearErrorClass(this.$element, 'editdescription');
        else {
            this.base.setErrorClass(this.$element, 'editdescription');
            this.descriptioniserror = true;
            result = false;
        }
        if (this.requestData.customer)
            this.base.clearErrorClass(this.$element, 'editcustomer');
        else {
            this.base.setErrorClass(this.$element, 'editcustomer');
            this.customeriserror = true;
            result = false;
        }
        return result;
    }

    public back() {
        this.base.goHome();
    }
}

export class ConfirmDeadlineComponent {
    static controllerId = 'ConfirmDeadlineComponent';

    constructor(
        @Inject('$uibModalInstance') private $modalInstance: angular.ui.bootstrap.IModalServiceInstance,
        @Inject('page') public page: RequestEntry
    ) {
    }

    public Yes() {
        this.$modalInstance.close('yes');
    }

    public No() {
        this.$modalInstance.close('no');
    }

    private remarkChanged(text: string) {
        this.page.deadlineRemark = text;
    }
}
